import { useState } from "react";
import { Box, AspectRatio, Icon, useColorModeValue } from "@chakra-ui/react";
import { FaPlay } from "react-icons/fa";

interface B2CVideoEmbedProps {
  youtubeId: string;
  title: string;
}

const B2CVideoEmbed: React.FC<B2CVideoEmbedProps> = ({ youtubeId, title }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const thumbnailUrl = `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;

  const overlayBg = useColorModeValue("blackAlpha.400", "blackAlpha.600");

  return (
    <AspectRatio ratio={16 / 9} borderRadius="2xl" overflow="hidden" shadow="2xl">
      {isPlaying ? (
        <Box as="iframe"
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          border="0"
        />
      ) : (
        <Box
          as="button"
          onClick={() => setIsPlaying(true)}
          position="relative"
          bgImage={`url(${thumbnailUrl})`}
          bgSize="cover"
          bgPosition="center"
          cursor="pointer"
          aria-label={`Play video: ${title}`}
        >
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            bg={overlayBg}
            display="flex"
            alignItems="center"
            justifyContent="center"
            transition="background 0.2s ease"
            _hover={{ bg: "blackAlpha.500" }}
          >
            <Box
              bg="white"
              borderRadius="full"
              width={{ base: "60px", md: "80px" }}
              height={{ base: "60px", md: "80px" }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              shadow="xl"
              transition="transform 0.2s ease"
              _hover={{ transform: "scale(1.08)" }}
            >
              <Icon as={FaPlay} boxSize={{ base: 5, md: 7 }} color="blue.600" ml="3px" />
            </Box>
          </Box>
        </Box>
      )}
    </AspectRatio>
  );
};

export default B2CVideoEmbed;